'use client';

import { PaginationWithInput } from '@ncai-axe/react-ui-v3';
import { useTranslations } from 'next-intl';
import { FlexContainer } from '../FlexContainer';

type PaginationProps = {
  currentPage: number;
  totalPageCount: number;
  visiblePageCount: number;
  onPageChange: (page: number) => void;
};

export default function Pagination({
  currentPage,
  totalPageCount,
  visiblePageCount,
  onPageChange,
}: PaginationProps) {
  const t = useTranslations('common');

  if (totalPageCount <= 1) {
    return null;
  }

  return (
    <FlexContainer height="fit-content">
      <PaginationWithInput
        currentPage={currentPage}
        totalPageCount={totalPageCount}
        visiblePageCount={visiblePageCount}
        onPageChange={onPageChange}
        buttonText={t('pagination.goTo')}
        navLabels={{
          first: t('pagination.first'),
          previous: t('pagination.previous'),
          next: t('pagination.next'),
          last: t('pagination.last'),
        }}
      />
    </FlexContainer>
  );
}
